<template>
	<svg
		width="200"
		height="100"
		viewBox="0 0 1200 600"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask
			id="mask0_160_147"
			style="mask-type: luminance"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="1200"
			height="600"
		>
			<path d="M0 0V600H1200V0H0Z" fill="white" />
		</mask>
		<g mask="url(#mask0_160_147)">
			<path d="M0 0V600H1200V0H0Z" fill="#012169" />
			<path d="M0 0L1200 600ZM1200 0L0 600Z" fill="black" />
			<path
				d="M0 0L1200 600M1200 0L0 600"
				stroke="white"
				stroke-width="120"
			/>
			<mask
				id="mask1_160_147"
				style="mask-type: luminance"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="1200"
				height="600"
			>
				<path
					d="M600 300H1200V600L600 300ZM600 300V600H0L600 300ZM600 300H0V0L600 300ZM600 300V0H1200L600 300Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask1_160_147)">
				<path d="M0 0L1200 600ZM1200 0L0 600Z" fill="black" />
				<path
					d="M0 0L1200 600M1200 0L0 600"
					stroke="#C8102E"
					stroke-width="80"
				/>
			</g>
			<path d="M600 0V600ZM0 300H1200Z" fill="black" />
			<path d="M600 0V600M0 300H1200" stroke="white" stroke-width="200" />
			<path d="M600 0V600ZM0 300H1200Z" fill="black" />
			<path
				d="M600 0V600M0 300H1200"
				stroke="#C8102E"
				stroke-width="120"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: "UnitedKingdom",
};
</script>
